exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".actions[data-v-06501a37]{margin:15px}", ""]);

// exports
